import DocViewer, { DocViewerRenderers } from '@cyntler/react-doc-viewer';
import UseModal from 'components/modal/useModal';
import { useEffect, useState, useRef, useMemo } from 'react';
import { toast } from 'react-toastify';
import {
  CardIdentity,
  CardVitale,
  Close,
  CrossIcon,
  Localisation,
  SelfieIdentity,
  ChevronDown,
} from '../../../../../../assets/icons';
import { dateToEpoch } from '../../../../../../helper/helper';
import UseContext from '../../../../../../hooks/useContext';
import Usefetchdata from '../../../../../../hooks/usefetchdata';
import ApiDatabase from '../../../../../../server';
import Button from '../../../../../button';
import ModalBody from '../../../../components/body';
import ModalFooter from '../../../../components/footer';

const AdminModalFileRefuse = () => {
  const { toggle } = UseModal();
  const {
    adminType,
    adminTempWorkerId,
    adminUserId,
    adminFileName,
    setUpdateTempWorker,
    setOpenModal,
  } = UseContext();
  const { userData } = Usefetchdata();
  const [reason, setReason] = useState('');
  const [reasonSearch, setReasonSearch] = useState('');
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const [tempWorkerInfos, setTempWorkerInfos] = useState({
    tempWorker: {},
    user: {},
  });
  const token = localStorage.getItem('xsrfToken');
  const [docs, setDocs] = useState([]);
  const [reasonRefusesDocuments, setReasonRefusesDocuments] = useState([]);
  const [viewerStyle, setViewerStyle] = useState({
    maxHeight: 700,
    pdfVerticalScrollByDefault: true,
  });
  const [isWaiting, setIsWaiting] = useState(true);

  useEffect(() => {
    if (userData._id && adminUserId && adminType) {
      manageFiles();
    }
  }, [adminType, adminUserId, userData]);

  const manageFiles = () => {
    if (!adminUserId || !adminType) {
      setDocs([]);
      return;
    }

    setIsWaiting(true);

    ApiDatabase.postPresignFiles(
      {
        token,
        idUser: adminUserId,
        type: adminType,
        fileName: adminFileName || '',
      },
      (data) => {
        const urls = Array.isArray(data?.urls) ? data.urls : [];
        const docsFromLinks = urls.filter(Boolean).map((item) => {
          const href = item.url || item.uri || '';
          let originalFileName = '';
          try {
            const u = new URL(href);
            originalFileName = decodeURIComponent(
              (u.pathname.split('/').pop() || '').trim()
            );
          } catch (e) {
            const clean = href.split('?')[0].split('#')[0];
            originalFileName = decodeURIComponent(
              (clean.split('/').pop() || '').trim()
            );
          }
          return {
            uri: href,
            fileName: originalFileName || 'document',
            fileType: item.type || 'application/pdf',
          };
        });
        setIsWaiting(false);
        setDocs(docsFromLinks);
      },
      (err) => {
        console.log(err);
        setDocs([]);
        setIsWaiting(false);
      }
    );
  };

  const type = {
    identity: {
      text: "Pièce d'identité",
      icon: <CardIdentity wh={24} color={'#6B7280'} />,
    },
    selfie: {
      text: "Selfie d'identité",
      icon: <SelfieIdentity wh={24} color={'#6B7280'} />,
    },
    visa: {
      text: 'Visa',
      icon: <CardIdentity wh={24} color={'#6B7280'} />,
    },
    card_vitality: {
      text: 'Carte Vitalité',
      icon: <CardVitale wh={24} color={'#6B7280'} />,
    },
    proof_of_address: {
      text: 'Justificatif de domicile',
      icon: <Localisation wh={24} color={'#6B7280'} />,
    },
    accommodation_of_address: {
      text: 'Attestation de logement',
      icon: <Localisation wh={24} color={'#6B7280'} />,
    },
    hostIdentity: {
      text: "Pièce d'identité de l'hôte",
      icon: <CardIdentity wh={24} color={'#6B7280'} />,
    },
  };

  useEffect(() => {
    if (userData._id) {
      if (token && adminTempWorkerId) {
        ApiDatabase.getTempWorkerById(
          { token, adminTempWorkerId },
          (data) => {
            setTempWorkerInfos((prevData) => ({
              ...prevData,
              tempWorker: data,
            }));
            const id_user = data.id_user;
            ApiDatabase.getUserById(
              { token, id_user },
              (data) => {
                const birthDay = dateToEpoch(data.birthday);
                setTempWorkerInfos((prevData) => ({
                  ...prevData,
                  user: {
                    ...data,
                    birthday:
                      ('0' + birthDay.getDate()).toString().slice(-2) +
                      '/' +
                      ('0' + (parseInt(birthDay.getMonth()) + 1))
                        .toString()
                        .slice(-2) +
                      '/' +
                      birthDay.getFullYear(),
                  },
                }));
              },
              (err) => {
                if (err.name !== 'CanceledError') {
                  console.log(err);
                }
              }
            );
          },
          (err) => {
            if (err.name !== 'CanceledError') {
              console.log(err);
            }
          }
        );
      } else {
        setTempWorkerInfos({
          tempWorker: {},
          user: {},
        });
        toast.error(
          'Une erreur est survenue, veuillez réessayer ou contacter le support'
        );
      }
    }
  }, [adminTempWorkerId, userData]);

  useEffect(() => {
    ApiDatabase.getReasonRefusesDocuments(
      { token },
      (data) => {
        setReasonRefusesDocuments(data ?? []);
      },
      (err) => {
        if (err.name !== 'CanceledError') {
          console.log(err);
        }
      }
    );
  }, []);

  // Fermer le dropdown quand on clique en dehors
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Filtrer les motifs de refus basé sur la recherche
  const filteredReasons = useMemo(() => {
    if (!reasonSearch.trim()) return reasonRefusesDocuments;
    const search = reasonSearch.toLowerCase().trim();
    return reasonRefusesDocuments.filter((r) =>
      r.name.toLowerCase().includes(search)
    );
  }, [reasonSearch, reasonRefusesDocuments]);

  // Sélectionner un motif
  const handleSelectReason = (reasonDoc) => {
    setReason(reasonDoc._id);
    setReasonSearch(reasonDoc.name);
    setIsDropdownOpen(false);
  };

  // Obtenir le nom du motif sélectionné
  const selectedReasonName = useMemo(() => {
    const found = reasonRefusesDocuments.find((r) => r._id === reason);
    return found?.name || '';
  }, [reason, reasonRefusesDocuments]);

  const modalRefuseSubmit = () => {
    if (reason.length > 0) {
      ApiDatabase.postRefuseTempWorkerFileAdmin(
        { token, adminTempWorkerId, adminType, reason },
        (data) => {
          toast.success('Fichier refusé avec succès');
          toggle();
          setUpdateTempWorker({ tempWorkerId: data._id, documentType: adminType, action: 'refuse' });
        }
      );
    } else {
      toast.error('Veuillez remplir le champ "Motif de refus"');
    }
  };

  const handleRetour = () => {
    toggle();
    if (adminType === 'identity') setOpenModal('ad_file_accept_identity');
    else if (adminType === 'visa') setOpenModal('ad_file_accept_visa');
    else if (adminType === 'selfie') setOpenModal('ad_file_accept_simple');
    else if (adminType === 'card_vitality') setOpenModal('ad_file_accept_card_vitality');
    else if (adminType === 'proof_of_address') setOpenModal('ad_file_accept_simple');
    else if (adminType === 'accommodation_of_address') setOpenModal('ad_file_accept_simple');
    else if (adminType === 'hostIdentity') setOpenModal('ad_file_accept_simple');
  };

  // Raccourcis clavier globaux
  useEffect(() => {
    const handleKeyDown = (e) => {
      // Ignorer si on est dans un input (sauf pour Escape)
      const isInInput = e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA';
      
      if (e.key === 'Escape') {
        e.preventDefault();
        handleRetour();
      } else if (e.key === 'Enter' && !isInInput) {
        e.preventDefault();
        modalRefuseSubmit();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [reason, adminType]);

  return (
    <>
      <ModalBody>
        <div className={'flex gap-3'}>
          <div className={'w-2/3'}>
            {isWaiting ? (
              <div className="flex flex-col shadow border rounded-md p-6 animate-pulse space-y-6">
                <div className="flex items-center space-x-4">
                  <div className="h-20 w-20 bg-gray-200 rounded"></div>
                  <div className="flex-1 space-y-3">
                    <div className="h-5 w-1/3 bg-gray-200 rounded"></div>
                    <div className="h-4 w-1/4 bg-gray-200 rounded"></div>
                  </div>
                </div>

                <div className="space-y-2">
                  <div className="h-4 w-1/5 bg-gray-200 rounded"></div>
                  <div className="h-3 w-2/3 bg-gray-200 rounded"></div>
                  <div className="h-3 w-3/4 bg-gray-200 rounded"></div>
                  <div className="h-3 w-1/2 bg-gray-200 rounded"></div>
                </div>

                <div className="space-y-2">
                  <div className="h-4 w-1/4 bg-gray-200 rounded"></div>
                  <div className="h-3 w-2/3 bg-gray-200 rounded"></div>
                  <div className="h-3 w-3/4 bg-gray-200 rounded"></div>
                  <div className="h-3 w-1/2 bg-gray-200 rounded"></div>
                </div>

                <div className="space-y-2">
                  <div className="h-4 w-1/4 bg-gray-200 rounded"></div>
                  <div className="h-3 w-2/3 bg-gray-200 rounded"></div>
                  <div className="h-3 w-3/4 bg-gray-200 rounded"></div>
                  <div className="h-3 w-1/2 bg-gray-200 rounded"></div>
                </div>

                <div className="space-y-2">
                  <div className="h-4 w-1/4 bg-gray-200 rounded"></div>
                  <div className="h-3 w-2/3 bg-gray-200 rounded"></div>
                  <div className="h-3 w-3/4 bg-gray-200 rounded"></div>
                </div>

                <div className="space-y-2">
                  <div className="h-4 w-1/4 bg-gray-200 rounded"></div>
                  <div className="grid grid-cols-2 gap-2">
                    <div className="h-3 w-3/4 bg-gray-200 rounded"></div>
                    <div className="h-3 w-2/3 bg-gray-200 rounded"></div>
                    <div className="h-3 w-1/2 bg-gray-200 rounded"></div>
                    <div className="h-3 w-2/5 bg-gray-200 rounded"></div>
                  </div>
                </div>
              </div>
            ) : (
              <>
                {docs.length > 0 ? (
                  <DocViewer
                    documents={docs}
                    style={viewerStyle}
                    pluginRenderers={DocViewerRenderers}
                  />
                ) : (
                  <div
                    className={
                      'flex justify-center items-center h-full py-3 px-1 border rounded'
                    }
                  >
                    <div className={'text-gray-500'}>
                      Aucun document à afficher.
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
          <div className={'w-1/3 flex flex-col gap-3'}>
            <div className={'w-full'}>
              <div className={'flex justify-between gap-5'}>
                <div className={'w-full'}>
                  <div className={'p-3 border rounded flex gap-3'}>
                    <div className={'my-auto'}>{type[adminType].icon}</div>
                    <div className={'my-auto ft-sm'}>
                      <div className={''}>
                        {adminType === 'identity' &&
                          (tempWorkerInfos.tempWorker.identity?.type ===
                          'Passeport'
                            ? 'Passeport'
                            : "Carte d'identité")}
                        {adminType === 'visa' &&
                          (tempWorkerInfos.tempWorker.visa?.type === 'Visa'
                            ? 'Visa'
                            : 'Titre de séjour')}
                        {adminType !== 'identity' &&
                          adminType !== 'visa' &&
                          type[adminType].text}
                      </div>
                      <div className={'text-gray-500'}>
                        {docs.length === 2
                          ? 'Recto & verso'
                          : docs.length > 2
                          ? 'Plusieurs documents'
                          : 'Document unique'}
                      </div>
                    </div>
                  </div>
                </div>
                <div className={''}>
                  <div className={'cursor-pointer'} onClick={toggle}>
                    <CrossIcon wh={20} color={'#374151'} />
                  </div>
                </div>
              </div>
            </div>
            {(() => {
              const tw = tempWorkerInfos.tempWorker;
              const docData = tw?.[adminType];
              const autoReason = docData?.reason;
              const isNotValidated = docData?.validated !== '2';
              if (autoReason && isNotValidated) {
                return (
                  <div className="p-3 bg-amber-50 border border-amber-200 rounded-lg">
                    <div className="ft-sm font-medium text-amber-800 mb-1">Analyse automatique :</div>
                    <div className="ft-sm text-amber-700 whitespace-pre-wrap">{autoReason}</div>
                  </div>
                );
              }
              return null;
            })()}
            <div className={'w-full'} ref={dropdownRef}>
              <label className={'ft-sm text-gray-500'}>Motif de refus</label>
              <div className="relative">
                <div className="relative">
                  <input
                    type="text"
                    className="w-full h-10 pl-3 pr-10 ft-b placeholder-gray-400 border rounded-lg focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:border-transparent"
                    placeholder="Rechercher un motif (1-9 pour sélection rapide)..."
                    value={reasonSearch}
                    onChange={(e) => {
                      setReasonSearch(e.target.value);
                      setReason('');
                      setIsDropdownOpen(true);
                    }}
                    onFocus={() => setIsDropdownOpen(true)}
                    onKeyDown={(e) => {
                      // Raccourcis 1-9 pour sélection rapide
                      const num = parseInt(e.key);
                      if (num >= 1 && num <= 9 && filteredReasons.length >= num) {
                        e.preventDefault();
                        handleSelectReason(filteredReasons[num - 1]);
                      }
                    }}
                  />
                  <div 
                    className="absolute right-3 top-1/2 -translate-y-1/2 cursor-pointer"
                    onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                  >
                    <ChevronDown wh={16} color="#6B7280" />
                  </div>
                </div>
                
                {isDropdownOpen && (
                  <div className="absolute z-10 w-full mt-1 bg-white border rounded-lg shadow-lg max-h-60 overflow-y-auto">
                    {filteredReasons.length > 0 ? (
                      filteredReasons.map((reasonDoc, index) => (
                        <div
                          key={reasonDoc._id}
                          className={`px-3 py-2 cursor-pointer hover:bg-gray-100 transition-colors flex items-center justify-between ${
                            reason === reasonDoc._id ? 'bg-yellow-50 text-yellow-700' : ''
                          }`}
                          onClick={() => handleSelectReason(reasonDoc)}
                        >
                          <span>{reasonDoc.name}</span>
                          {index < 9 && (
                            <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center border border-gray-200 rounded text-xs text-gray-500 bg-gray-50">
                              {index + 1}
                            </span>
                          )}
                        </div>
                      ))
                    ) : (
                      <div className="px-3 py-2 text-gray-500 text-sm">
                        Aucun motif trouvé
                      </div>
                    )}
                  </div>
                )}
              </div>
              {selectedReasonName && !isDropdownOpen && (
                <div className="mt-1 text-xs text-green-600">
                  ✓ {selectedReasonName}
                </div>
              )}
            </div>
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button size={'LG'} color={'SECONDARY'} onClick={handleRetour}>
          Retour
        </Button>
        <Button size={'LG'} color={'PRIMARY'} onClick={modalRefuseSubmit}>
          <div className={'flex gap-2'}>
            <div className={'my-auto'}>
              <Close wh={20} color={'#ffff'} />
            </div>
            <div className={'my-auto'}>Refuser</div>
          </div>
        </Button>
      </ModalFooter>
    </>
  );
};

export default AdminModalFileRefuse;
